var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Wapper",class:{ border: _vm.border }},[_c('div',{staticClass:"warpper-title"},[_vm._v(" "+_vm._s(_vm.title)),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.more),expression:"more"}],on:{"click":_vm.seeMore}},[_vm._v("更多>")])]),_c('div',{style:({ padding: `${_vm.padding}px` })},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }